import List from './list'
import Edit from './edit'

export default {
  List,
  Edit,
}
